import { render, staticRenderFns } from "./emailPreviewModal.vue?vue&type=template&id=5b5ef375&scoped=true&"
import script from "./emailPreviewModal.vue?vue&type=script&lang=js&"
export * from "./emailPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./emailPreviewModal.vue?vue&type=style&index=0&id=5b5ef375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ef375",
  null
  
)

export default component.exports